import apiClient from 'api/services/apiClient';
import { MESSAGE_COMMON } from 'constants/string/messages';
import { isApiResponseError, validateMessageResponse } from 'utils/helper';

/**
 * @name getListConversations
 * @description Get the list of conversations
 * @response success - 200 OK
 * @response failure - 404 Not Found
 * @returns {object} response.data
 */
export const getListConversations = async (queryString = '') => {
  const response = await apiClient.request('GET', `/admin/chat/conversations${queryString}`);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name getListHistory
 * @description Get the list of history
 * @param {string} conversation_id
 * @param {string} query
 * @param {string} query.page
 * @param {string} query.limit
 * @response success - 200 OK
 * @response failure - 404 Not Found
 * @returns {object} response.data
 */
export const getListHistory = async (conversation_id, query = '') => {
  const response = await apiClient.request('GET', `/admin/chat/history/${conversation_id}${query}`);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name createRoom
 * @description Create a new room
 * @param {string} queryString
 * @returns {Promise<void>}
 */
export const createConversation = async (queryString) => {
  const response = await apiClient.request('POST', `/admin/chat/create-conversation${queryString}`);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name readMessages
 * @description Read a conversation
 * @param {string} queryString
 * @returns {Promise<void>}
 */
export const readMessages = async (queryString) => {
  const response = await apiClient.request('POST', `/admin/chat/read-messages${queryString}`);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name getHistoryChatByChildId
 * @description Get the history chat by child id
 * @param {string} child_id
 * @param {string} queryString
 * @returns {Promise<void>}
 */
export const getHistoryChatByChildId = async (child_id, queryString = '') => {
  const response = await apiClient.request('GET', `/admin/chat/history/get-by/${child_id}${queryString}`);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};
